/**
 * As oito abas do combustível, na ordem do pedido do dono (25/09).
 *
 * "Ordens de abastecimento", e não "Ordens de Serviço" como o pedido chamou:
 * ordem de serviço no sistema é a da oficina (módulo 06), e duas coisas com o
 * mesmo nome em módulos vizinhos é como uma pessoa abre a errada.
 *
 * Cadastros por último, pelo mesmo motivo do menu antigo: cadastro se faz uma
 * vez, e a leitura é da esquerda para a direita pelo que se faz todo dia.
 */
export const ABAS_DO_COMBUSTIVEL = [
  {
    rotulo: 'Visão geral e lançamentos',
    para: '/combustivel',
    explicacao: 'Os abastecimentos lançados, por equipamento e por obra.',
  },
  {
    rotulo: 'Lançamentos',
    para: '/combustivel/lancamento',
    explicacao:
      'A lista do dia com a verificação de cada lançamento, a linha rápida para lançar pelo teclado e o detalhe com o consumo contra a faixa da máquina.',
  },
  {
    /* A entrega de 25/10/2026 separou as duas: a linha rápida acima responde
       quatro perguntas e dá conta do dia a dia; esta tela é o resto — posto,
       lubrificante, data retroativa, ordem e as pessoas. */
    rotulo: 'Lançamento completo',
    para: '/combustivel/lancamento/completo',
    explicacao:
      'O formulário inteiro: abastecimento no posto com cupom, data retroativa, ordem de abastecimento e quem operou.',
  },
  {
    rotulo: 'Tanques e volume',
    para: '/combustivel/tanques',
    explicacao: 'O volume de cada tanque contra a capacidade, os lançamentos de cada um e os ajustes esperando aprovação.',
  },
  {
    rotulo: 'Ordens de abastecimento',
    para: '/combustivel/ordens',
    explicacao: 'O que foi autorizado, o que foi entregue e o que ainda resta, em colunas diferentes.',
  },
  {
    rotulo: 'Consumo e lubrificantes',
    para: '/combustivel/consumo',
    explicacao: 'O consumo de cada máquina contra a faixa esperada, e o lubrificante aplicado.',
  },
  {
    rotulo: 'Cobranças dos postos',
    para: '/combustivel/cobrancas',
    explicacao: 'O que o posto cobrou, ao lado do que foi lançado no sistema.',
  },
  {
    rotulo: 'Folhas de campo',
    para: '/combustivel/folhas',
    explicacao:
      'A folha impressa de uma máquina, por um tanque, num período. Quem abastece preenche; quem escaneia confere o que a IA leu e lança.',
  },
  {
    rotulo: 'Cadastros',
    para: '/combustivel/cadastros',
    explicacao: 'Tanque, posto e produto. Eles precisam existir antes do primeiro abastecimento: é daqui que saem as listas de escolha do lançamento.',
  },
] as const;

export type AbaDoCombustivel = (typeof ABAS_DO_COMBUSTIVEL)[number];

/**
 * A aba do caminho. Pelo prefixo MAIS LONGO, e não pelo primeiro que casa:
 * `/combustivel` é prefixo de todas, e `/combustivel/folhas/abc` é da aba de
 * folhas. Caminho que não é de aba nenhuma cai na visão geral.
 */
export function abaAtiva(caminho: string): AbaDoCombustivel {
  let melhor: AbaDoCombustivel = ABAS_DO_COMBUSTIVEL[0];
  for (const aba of ABAS_DO_COMBUSTIVEL) {
    if ((caminho === aba.para || caminho.startsWith(`${aba.para}/`)) && aba.para.length > melhor.para.length) {
      melhor = aba;
    }
  }
  return melhor;
}
